module.exports = __webpack_public_path__ + "static/media/zocaloPvc2.83d43bce.jpg";